const cardsData = [
  {
    img: "https://readdy.ai/api/search-image?query=A%20dramatic%20crime%20thriller%20film%20scene%20with%20rainy%20city%20streets%20at%20night%2C%20neon%20reflections%2C%20mysterious%20atmosphere%2C%20warm%20amber%20street%20lights%2C%20cinematic%20composition%2C%20professional%20film%20photography%2C%20clean%20aesthetic%2C%20editorial%20quality&width=600&height=340&seq=card-01&orientation=landscape",
    tag: '悬疑犯罪',
    title: '逆光追凶',
    rating: '9.2',
    info: '2026 · 犯罪 · 悬疑',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20beautiful%20ancient%20Chinese%20fantasy%20drama%20scene%20with%20flowing%20robes%20and%20ethereal%20lighting%2C%20traditional%20architecture%20background%2C%20soft%20warm%20golden%20tones%2C%20cinematic%20depth%2C%20professional%20film%20photography%2C%20clean%20composition&width=600&height=340&seq=card-02&orientation=landscape",
    tag: '古装仙侠',
    title: '星河万里',
    rating: '8.8',
    info: '2026 · 仙侠 · 言情',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20colorful%20animated%20fantasy%20world%20with%20futuristic%20sci-fi%20elements%2C%20vibrant%20warm%20colors%2C%20stylized%20character%20design%2C%20epic%20landscape%2C%20professional%20animation%20art%20direction%2C%20clean%20composition%2C%20editorial%20quality&width=600&height=340&seq=card-03&orientation=landscape",
    tag: '科幻动画',
    title: '星域纪元',
    rating: '9.0',
    info: '2026 · 科幻 · 热血',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20romantic%20comedy%20scene%20in%20a%20modern%20urban%20setting%2C%20two%20people%20in%20a%20cozy%20cafe%2C%20warm%20natural%20lighting%2C%20soft%20bokeh%20background%2C%20feel-good%20atmosphere%2C%20professional%20film%20photography%2C%20clean%20composition%2C%20editorial%20quality&width=600&height=340&seq=card-04&orientation=landscape",
    tag: '都市爱情',
    title: '遇见你的那天',
    rating: '8.5',
    info: '2026 · 爱情 · 都市',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20tense%20Korean%20thriller%20film%20scene%20with%20foggy%20mountain%20landscape%2C%20mysterious%20figure%20in%20distance%2C%20cold%20and%20warm%20color%20contrast%2C%20cinematic%20suspense%20mood%2C%20professional%20film%20photography%2C%20clean%20composition%2C%20editorial%20quality&width=600&height=340&seq=card-05&orientation=landscape",
    tag: '韩剧精选',
    title: '迷雾追踪',
    rating: '9.1',
    info: '2026 · 悬疑 · 剧情',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20variety%20show%20travel%20scene%20with%20group%20of%20people%20in%20beautiful%20natural%20landscape%2C%20sunny%20day%2C%20warm%20golden%20light%2C%20joyful%20atmosphere%2C%20professional%20television%20production%20quality%2C%20clean%20composition%2C%20editorial%20quality&width=600&height=340&seq=card-06&orientation=landscape",
    tag: '热门综艺',
    title: '说走就走 S3',
    rating: '8.7',
    info: '2026 · 旅行 · 真人秀',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20historical%20war%20epic%20film%20scene%20with%20ancient%20Chinese%20battlefield%2C%20dramatic%20sky%2C%20warm%20golden%20and%20crimson%20tones%2C%20large-scale%20cinematic%20composition%2C%20professional%20film%20photography%2C%20editorial%20quality%2C%20high%20detail&width=600&height=340&seq=card-07&orientation=landscape",
    tag: '历史战争',
    title: '铁血山河',
    rating: '8.9',
    info: '2026 · 历史 · 战争',
  },
];

export function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精选推荐</h2>
          <a href="#index" className="text-sm text-primary-500 hover:text-primary-600 whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
          {cardsData.map((card, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-200/60 transition-all hover:-translate-y-1"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-500/90 text-background-50 whitespace-nowrap">
                    {card.rating}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/30">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-3">
                <span className="text-xs text-accent-600 whitespace-nowrap">{card.tag}</span>
                <h3 className="font-heading text-sm text-foreground-900 mt-1 whitespace-nowrap overflow-hidden text-ellipsis">{card.title}</h3>
                <p className="text-xs text-foreground-600 mt-1">{card.info}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

const indexData = [
  { icon: 'ri-movie-line', title: '动作电影', count: '1,286部', desc: '热血枪战、极限追逐、硬核格斗' },
  { icon: 'ri-emotion-happy-line', title: '喜剧电影', count: '892部', desc: '爆笑不断、轻松减压、欢乐无限' },
  { icon: 'ri-heart-line', title: '爱情电影', count: '756部', desc: '甜蜜浪漫、感人至深、心动瞬间' },
  { icon: 'ri-ghost-line', title: '悬疑惊悚', count: '643部', desc: '烧脑反转、紧张刺激、细思极恐' },
  { icon: 'ri-rocket-line', title: '科幻大片', count: '518部', desc: '未来世界、视觉奇观、想象力爆炸' },
  { icon: 'ri-ancient-gate-line', title: '古装历史', count: '621部', desc: '权谋争霸、宫廷风云、历史重现' },
  { icon: 'ri-tv-line', title: '热门综艺', count: '1,034期', desc: '旅行真人秀、音乐竞演、脱口秀' },
];

export function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          分类导航
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="flex flex-col items-center p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300/60 hover:bg-accent-50/50 transition-all cursor-pointer group"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">{item.title}</span>
              <span className="text-xs text-accent-600 mb-2">{item.count}</span>
              <span className="text-xs text-foreground-600 text-center leading-relaxed">{item.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '全站支持1080P至4K超清画质，搭配杜比音效，带来影院级的视听享受，每一帧都清晰动人。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '采用智能CDN分发与自适应码率技术，无论网络环境如何，都能确保91在线视频播放不卡顿。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '内容团队7×24小时轮班更新，每天上线200+部新内容，涵盖91视频、久久视频等全品类资源。',
  },
  {
    icon: 'ri-device-line',
    title: '全设备兼容',
    desc: '完美适配电脑、平板、手机等多终端，支持投屏功能，随时随地畅享高清观影体验。',
  },
];

export function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200/60 transition-colors text-center group"
            >
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 mx-auto group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20professional%20portrait%20avatar%20of%20a%20young%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20neutral%20expression%2C%20clean%20background%2C%20soft%20natural%20light%2C%20professional%20headshot%20quality&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '影迷小陈',
    text: '桃花视频真的太好用了！91在线视频资源超全，追了三部韩剧都是高清全集，而且真的不缓冲，推荐给所有追剧党！',
    time: '2小时前',
    likes: 128,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20professional%20portrait%20avatar%20of%20a%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20friendly%20expression%2C%20clean%20background%2C%20soft%20natural%20light%2C%20professional%20headshot%20quality&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '剧荒终结者',
    text: '每天打开桃花看看更新片单已经成了习惯，最近那部《逆光追凶》看得太过瘾了，演技和剧情都在线！',
    time: '5小时前',
    likes: 96,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20professional%20portrait%20avatar%20of%20a%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20calm%20expression%2C%20clean%20background%2C%20soft%20natural%20light%2C%20professional%20headshot%20quality&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '深夜观影人',
    text: '之前用其他平台老是卡，桃花视频的流畅度真的没话说。关键是91视频网站的内容更新速度超快，大结局一出来就能看。',
    time: '昨天',
    likes: 203,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20professional%20portrait%20avatar%20of%20a%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20thoughtful%20expression%2C%20clean%20background%2C%20soft%20natural%20light%2C%20professional%20headshot%20quality&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '国漫爱好者',
    text: '国漫专区做得太用心了！《星域纪元》每一帧都可以当壁纸，桃花视频的4K画质完美呈现了制作组的诚意。',
    time: '2天前',
    likes: 157,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20professional%20portrait%20avatar%20of%20a%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20happy%20expression%2C%20clean%20background%2C%20soft%20natural%20light%2C%20professional%20headshot%20quality&width=120&height=120&seq=avatar-05&orientation=squarish',
    name: '综艺达人',
    text: '《说走就走S3》太好看了！每周准时在桃花视频等更新，画面清晰、弹幕欢乐，追综艺体验一级棒！',
    time: '3天前',
    likes: 89,
  },
];

export function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          观众热评
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-900 whitespace-nowrap">{c.name}</div>
                  <div className="text-xs text-foreground-600">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-3">
                {c.text}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-600">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}